<template>
    <v-img ref="avatar" :src="userAvatar"></v-img>
</template>

<script>

import awsS3Helper from '@/helpers/aws-s3'

export default {
    data() {
        return {}
    },   
    methods: {
        refreshAvatar() {
            this.$refs.avatar.src = awsS3Helper.getProfileAvatarUrl(this.$store.state.userId)
        }
    },
    computed: {
        userAvatar() {
            return awsS3Helper.getProfileAvatarUrl(this.$store.state.userId)
        }
    },
    mounted() {
        this.$root.$on('updateUserAvatar', (data) => {
            if (data=='updateUserAvatarHandler') this.refreshAvatar()
        })
    }
}
</script>